import type React from 'react'
import { useState } from 'react'

import TextInput from '@/components/DEPRECATED_UI/TextInput'
import { Select, ItemHeader } from '@/components/Style/Common'
import type { IndependentMeansIncome } from '@/types/AddIncome'

import type { PropertyDispatch } from './Behaviour/PropertyDispatch'
import { Property } from './Behaviour/PropertyDispatch'
import IncomePropertiesInput from './IncomePropertiesInput'

interface Props {
  income: IndependentMeansIncome
  propertyDispatch: PropertyDispatch
}

export const MEAN_TYPE_OPTIONS = [
  { label: 'Pension', value: 'pension' },
  { label: 'Savings', value: 'savings' },
  { label: 'Investments', value: 'investments' },
]

const IndependentMeansInput: React.FC<Props> = ({ income, propertyDispatch }) => {
  const [meansType, setMeansType] = useState(MEAN_TYPE_OPTIONS[0].value) // eslint-disable-line @typescript-eslint/no-unused-vars
  const [pensionProvider, setPensionProvider] = useState('') // eslint-disable-line @typescript-eslint/no-unused-vars
  return (
    <div>
      <ItemHeader>Means Type</ItemHeader>
      <Select
        value={income.meansType}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          setMeansType(e.target.value)
          income.meansType = e.target.value
        }}
      >
        {MEAN_TYPE_OPTIONS.map(({ label, value }, i) => (
          <option key={i} value={value}>
            {label}
          </option>
        ))}
      </Select>
      {
        // eslint-disable-next-line eqeqeq
        income.meansType == 'pension' && (
          <div>
            <ItemHeader>Pension Provider</ItemHeader>
            <TextInput
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPensionProvider(e.target.value)
                income.pensionsProvider = e.target.value
              }}
              value={income.pensionsProvider}
              label="Pension Provider"
            />
          </div>
        )
      }
      <IncomePropertiesInput
        incomeProperties={income.incomeProperties}
        propertyDispatch={propertyDispatch}
        amountProperty={Property.IncomeAmount}
        frequencyProperty={Property.IncomeFrequency}
      />
    </div>
  )
}

export default IndependentMeansInput
